import React from 'react';
import '../styles/LoadingSpinner.scss';

const LoadingSpinner = ({ size = 'extra-large' }) => (
  <div className={`loading-spinner ${size}`} data-testid="loading-spinner-container">
    <div className={`spinner ${size}`} data-testid="loading-spinner"></div>
  </div>
);

export default LoadingSpinner;